<template>
  <div>
    <div class="sidebar stick" id="number">
      <b-button
        variant="outline-info"
        v-for="(item, idx) in questions"
        :key="item"
      >
        {{ idx + 1 }}
      </b-button>
    </div>
    <b-card>
      <b-row>
        <b-col lg="9"></b-col>
        <b-col lg="3">
          <flip-clock dir="ltr" ref="flipclock" :options="options" />
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-card-title>
        <h3 class="card-label" id="question">
          {{ index + "-" + questions[index - 1].question }}
        </h3>
      </b-card-title>
      <b-card-body>
        <quiz-vue :answers="questions[index - 1].answers" />
      </b-card-body>
      <b-card-footer class="d-flex justify-content-between">
        <b-button
          variant="relief-primary"
          class="col-4"
          v-if="index != 1"
          @click="index--"
          >سابق</b-button
        >
        <b-button
          variant="relief-info"
          class="col-4"
          v-if="questions.length > index"
          @click="index++"
          >التالي</b-button
        >
        <b-button
          variant="relief-success"
          class="col-4"
          v-if="questions.length == index"
          >انتهى</b-button
        >
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { FlipClock } from "@mvpleung/flipclock";
import quizVue from "./components/quiz.vue";
import ExamsController from "@/Controllers/ExamsController";
let ctx = new ExamsController();
export default {
  
  name: "Exam",
  props: {
    examId:0
  },
  components: {
    FlipClock,
    quizVue,
  },
  data() {
    return {
      options: {
        digit: 120,
        countdown: true,
        clockFace: "MinuteCounter",
        callbacks: {
          stop: function () {
            // alert("The clock has stopped!");
          },
        },
      },
      questions: {},
      index: 1,
    };
  },
  async created() {
    var id = this.$route.params.id;
     if (!id) id = this.examId;
    let res = await ctx.getQuestions(id);
    this.questions = res;
    console.log(this.questions);
     let ex = await ctx.Show(id);
    this.options.digit = 60 * ex.exam.time;
  },
  methods: {},
};
</script>

<style>
.answer {
  margin-bottom: 2%;
}

.question {
  margin-bottom: 3%;
}

#div2 {
  border: 1px solid;
}

#div1 {
  border: 1px solid;
}

label.btn {
  padding: 18px 60px;
  white-space: normal;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -o-transform: scale(1);
  -webkit-transition-duration: 0.3s;
  -moz-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
}

label.btn:hover {
  text-shadow: 0 3px 2px rgba(0, 0, 0, 0.4);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
}

label.btn-block {
  text-align: left;
  position: relative;
}

label .btn-label {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  padding: 0 10px;
  background: #000000;
  height: 100%;
}

label .glyphicon {
  top: 34%;
}

.element-animation1 {
  animation: animationFrames ease 0.8s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
  -webkit-animation: animationFrames ease 0.8s;
  -webkit-animation-iteration-count: 1;
  -webkit-transform-origin: 50% 50%;
  -ms-animation: animationFrames ease 0.8s;
  -ms-animation-iteration-count: 1;
  -ms-transform-origin: 50% 50%;
}

@keyframes animationFrames {
  0% {
    opacity: 0;
    transform: translate(-1500px, 0px);
  }

  60% {
    opacity: 1;
    transform: translate(30px, 0px);
  }

  80% {
    transform: translate(-10px, 0px);
  }

  100% {
    opacity: 1;
    transform: translate(0px, 0px);
  }
}

@-webkit-keyframes animationFrames {
  0% {
    opacity: 0;
    -webkit-transform: translate(-1500px, 0px);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate(30px, 0px);
  }

  80% {
    -webkit-transform: translate(-10px, 0px);
  }

  100% {
    opacity: 1;
    -webkit-transform: translate(0px, 0px);
  }
}
.exam {
  height: 600px;
}
.sidebar {
  background-color: #ffffff;
  min-height: 200px;
  padding: 15px;
  color: rgb(0, 0, 0);
  margin: 25px 0px;
  z-index: 100;
  border: 2px solid #ccc !important;
  border-radius: 0px 16px 0px 16px;
}

.stick {
  position: fixed;
  width: 300px;
  bottom: 00px;
  right: 15px !important;
  height: 200px;
  overflow: auto;
}

#origin {
  background-color: lightgreen;
}

#origin img,
#drop img {
  margin-top: 3px;
  margin-left: 5px;
}

#drop {
  background-color: red;
  min-height: 120px;
}

.over {
  border: solid 5px purple;
}

.draggable {
  border: solid 2px gray;
}

#examCounterId {
  margin-left: 10px;
  font-size: 1.5rem;
}
</style>
